var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40002 9.00063C5.40002 8.47563 5.60252 7.95062 6.00002 7.55312L10.89 2.66312C11.1075 2.44562 11.4675 2.44562 11.685 2.66313C11.9025 2.88063 11.9025 3.24063 11.685 3.45813L6.79502 8.34812C6.43502 8.70812 6.43502 9.29312 6.79502 9.65313L11.685 14.5431C11.9025 14.7606 11.9025 15.1206 11.685 15.3381C11.4675 15.5556 11.1075 15.5556 10.89 15.3381L6.00002 10.4481C5.60252 10.0506 5.40002 9.52562 5.40002 9.00063Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevArrow);
export default __webpack_public_path__ + "static/media/prev-arrow.e49af7a9eea739e0ecab0a514800aef6.svg";
export { ForwardRef as ReactComponent };